import React, { useState, useEffect, Fragment } from "react"
import { graphql } from "gatsby"
import { injectIntl, Link } from "gatsby-plugin-intl"
import styled from "@emotion/styled"

import { SectionContainer } from "../../components/Layout/styled"
import CustomerFeedbackSlider from "../../components/CustomerFeedbackSlider"
import BusinessSlider from "../../components/BusinessSlider"
import ScientificExpertSlider from "../../components/ScientificExpertSlider"
import ProductExpert from "../../components/Products/ProductExpert"

import Footer from "../../components/Layout/Footer"
import SeoComp from "../../components/SeoComp"
import { isBrowser } from "../../context/ApolloContext"
import { GatsbyImage } from "gatsby-plugin-image"

const $ = isBrowser ? require("jquery") : {}

const ScientificStudy = ({ intl, data }) => {
  const [showReference, setshowReference] = useState(true)
  const handleVisibility = () => {
    let visibility = showReference
    setshowReference(!visibility)
  }

  const handleHashScrolling = () => {
    $(document).ready(function() {
      $("html, body").hide()
      if (window.location.hash === "#experts") {
        setTimeout(function() {
          $("html, body")
            .scrollTop(0)
            .show()
          $("html, body").animate(
            {
              scrollTop:
                $(window.location.hash + "_section").offset().top - 100,
            },
            1500
          )
        }, 0)
      } else if (window.location.hash === "#entreprise") {
        setTimeout(function() {
          $("html, body")
            .scrollTop(0)
            .show()
          $("html, body").animate(
            {
              scrollTop: $(window.location.hash).offset().top - 100,
            },
            1500
          )
        }, 0)
      } else {
        $("html, body").show()
      }
    })
  }

  useEffect(() => {
    isBrowser && handleHashScrolling()
  }, [intl.locale])
  return (
    data &&
    data.allDirectusScientificStudyTranslation.nodes.length > 0 && (
      <Fragment>
        <SeoComp
          description={
            data.allDirectusSeoTranslation.nodes[0] &&
            data.allDirectusSeoTranslation.nodes[0].meta_description
          }
          title={
            data.allDirectusSeoTranslation.nodes[0] &&
            data.allDirectusSeoTranslation.nodes[0].meta_title
          }
          twitter_card={
            data.allDirectusSeoTranslation.nodes[0] &&
            data.allDirectusSeoTranslation.nodes[0].twitter_card
          }
          image={
            data.allDirectusSeoTranslation.nodes[0] &&
            data.allDirectusSeoTranslation.nodes[0].image &&
            data.allDirectusSeoTranslation.nodes[0].image.data &&
            data.allDirectusSeoTranslation.nodes[0].image.data.url
          }
          hreflangPathname={{
            fr: "dispositif-medical",
            en:
              process.env.GATSBY_ACTIVE_ENV === "usd"
                ? "medical-device"
                : "scientific-study",
            de: "scientific-study",
            es: "scientific-study",
          }}
        />

        <SectionContainer>
          <BannerSection>
            {data.allDirectusScientificStudyTranslation.nodes[0]
              .top_banner_image &&
              data.allDirectusScientificStudyTranslation.nodes[0]
                .top_banner_image.data.url && (
                <TopBannerImage
                  objectFit="contain"
                  image={
                    data.allDirectusScientificStudyTranslation.nodes[0]
                      .top_banner_image.localFile.childImageSharp
                      .gatsbyImageData
                  }
                  alt=""
                />
              )}
            <BannerText>
              {data.allDirectusScientificStudyTranslation.nodes[0]
                .top_banner_title && (
                <BannerTitle
                  dangerouslySetInnerHTML={{
                    __html:
                      data.allDirectusScientificStudyTranslation.nodes[0]
                        .top_banner_title,
                  }}
                />
              )}
              {data.allDirectusScientificStudyTranslation.nodes[0]
                .top_banner_text && (
                <BannerSubTitle
                  dangerouslySetInnerHTML={{
                    __html:
                      data.allDirectusScientificStudyTranslation.nodes[0]
                        .top_banner_text,
                  }}
                />
              )}
            </BannerText>
          </BannerSection>
          {data.allDirectusScientificStudyTranslation.nodes[0]
            .top_banner_text && (
            <MobileBannerSubTitle
              dangerouslySetInnerHTML={{
                __html:
                  data.allDirectusScientificStudyTranslation.nodes[0]
                    .top_banner_text,
              }}
            />
          )}

          <PageSection>
            <Container>
              {data.allDirectusScientificStudyTranslation.nodes[0]
                .lyne_product_section_title && (
                <SectionTitle
                  dangerouslySetInnerHTML={{
                    __html:
                      data.allDirectusScientificStudyTranslation.nodes[0]
                        .lyne_product_section_title,
                  }}
                  id="lyne_dm"
                />
              )}
              {data.allDirectusScientificStudyTranslation.nodes[0]
                .lyne_product_section_subtitle && (
                <ProductSectionSubTitle
                  dangerouslySetInnerHTML={{
                    __html:
                      data.allDirectusScientificStudyTranslation.nodes[0]
                        .lyne_product_section_subtitle,
                  }}
                />
              )}
              {data.allDirectusScientificStudyTranslation.nodes[0]
                .lyne_product_action && (
                <ProductActionSection>
                  {data.allDirectusScientificStudyTranslation.nodes[0].lyne_product_action.list.map(
                    (item, index) => {
                      return (
                        <ProductActionBox key={index.toString()}>
                          {item.image && (
                            <ProductActionImage
                              className="lazyload"
                              data-src={item.image}
                            />
                          )}
                          {item.text && (
                            <ProductActionText>{item.text}</ProductActionText>
                          )}
                        </ProductActionBox>
                      )
                    }
                  )}
                </ProductActionSection>
              )}
              <ProductTextSection>
                <LeftSection>
                  {data.allDirectusScientificStudyTranslation.nodes[0]
                    .lyne_product_text && (
                    <Text
                      dangerouslySetInnerHTML={{
                        __html:
                          data.allDirectusScientificStudyTranslation.nodes[0]
                            .lyne_product_text,
                      }}
                    />
                  )}
                  {data.allDirectusScientificStudyTranslation.nodes[0]
                    .lyne_product_button_text && (
                    <ProductButton
                      to={
                        process.env.GATSBY_CURRENCY_TYPE === "eur" &&
                        intl.locale === "fr"
                          ? "/shop/solutions-textiles/"
                          : "/shop/"
                      }
                    >
                      {
                        data.allDirectusScientificStudyTranslation.nodes[0]
                          .lyne_product_button_text
                      }
                    </ProductButton>
                  )}
                </LeftSection>
                <RightSection>
                  {data.allDirectusScientificStudyTranslation.nodes[0]
                    .lyne_product_right_image &&
                    data.allDirectusScientificStudyTranslation.nodes[0]
                      .lyne_product_right_image.data.url && (
                      <RightImage
                        objectFit="contain"
                        image={
                          data.allDirectusScientificStudyTranslation.nodes[0]
                            .lyne_product_right_image.localFile.childImageSharp
                            .gatsbyImageData
                        }
                        alt=""
                      />
                    )}
                </RightSection>
              </ProductTextSection>
            </Container>
          </PageSection>
          <PageSection background="#F8F8F8">
            <Container>
              {data.allDirectusScientificStudyTranslation.nodes[0]
                .proven_effect_section_title && (
                <SectionTitle
                  dangerouslySetInnerHTML={{
                    __html:
                      data.allDirectusScientificStudyTranslation.nodes[0]
                        .proven_effect_section_title,
                  }}
                  id="efficacite_prouvee"
                  marginBottom="25px"
                />
              )}

              {data.allDirectusScientificStudyTranslation.nodes[0]
                .proven_effect_section_text && (
                <Text
                  dangerouslySetInnerHTML={{
                    __html:
                      data.allDirectusScientificStudyTranslation.nodes[0]
                        .proven_effect_section_text,
                  }}
                />
              )}
            </Container>
          </PageSection>
          <PageSection>
            <Container>
              {data.allDirectusScientificStudyTranslation.nodes[0]
                .customer_feedback_title && (
                <Title
                  dangerouslySetInnerHTML={{
                    __html:
                      data.allDirectusScientificStudyTranslation.nodes[0]
                        .customer_feedback_title,
                  }}
                  id="client"
                />
              )}
              <CustomerFeedbackBottomSection>
                {data.allDirectusScientificStudyTranslation.nodes[0]
                  .customer_feedback_bottom_section.right_section.title && (
                  <RightTitle
                    dangerouslySetInnerHTML={{
                      __html:
                        data.allDirectusScientificStudyTranslation.nodes[0]
                          .customer_feedback_bottom_section.right_section.title,
                    }}
                  />
                )}
                {data.allDirectusScientificStudyTranslation.nodes[0]
                  .customer_feedback_bottom_section.right_section.title && (
                  <ProcessBar />
                )}
                {data.allDirectusScientificStudyTranslation.nodes[0]
                  .customer_feedback_bottom_section.right_section.subtitle && (
                  <RightSubTitle
                    dangerouslySetInnerHTML={{
                      __html:
                        data.allDirectusScientificStudyTranslation.nodes[0]
                          .customer_feedback_bottom_section.right_section
                          .subtitle,
                    }}
                  />
                )}
                {data.allDirectusScientificStudyTranslation.nodes[0]
                  .customer_feedback_bottom_section.mobile_text && (
                  <SmallText
                    dangerouslySetInnerHTML={{
                      __html:
                        data.allDirectusScientificStudyTranslation.nodes[0]
                          .customer_feedback_bottom_section.mobile_text,
                    }}
                  />
                )}
              </CustomerFeedbackBottomSection>
              {data.allDirectusScientificStudyTranslation.nodes[0]
                .customer_feedback_slider && (
                <CustomerFeedbackSlider
                  data={
                    data.allDirectusScientificStudyTranslation.nodes[0]
                      .customer_feedback_slider
                  }
                />
              )}
            </Container>
          </PageSection>
          <PageSection background="#F8F8F8">
            <Container>
              {data.allDirectusScientificStudyTranslation.nodes[0]
                .business_result_title && (
                <Title
                  dangerouslySetInnerHTML={{
                    __html:
                      data.allDirectusScientificStudyTranslation.nodes[0]
                        .business_result_title,
                  }}
                  id="entreprise"
                />
              )}
              {data.allDirectusScientificStudyTranslation.nodes[0]
                .business_result_slider && (
                <BusinessSlider
                  data={
                    data.allDirectusScientificStudyTranslation.nodes[0]
                      .business_result_slider
                  }
                />
              )}
            </Container>
          </PageSection>
          <PageSection>
            <Container>
              {data.allDirectusScientificStudyTranslation.nodes[0]
                .laboratory_test_title && (
                <Title
                  dangerouslySetInnerHTML={{
                    __html:
                      data.allDirectusScientificStudyTranslation.nodes[0]
                        .laboratory_test_title,
                  }}
                  marginBottom="25px"
                  id="laboratoire"
                />
              )}
              {data.allDirectusScientificStudyTranslation.nodes[0]
                .laboratory_test_text && (
                <Text
                  dangerouslySetInnerHTML={{
                    __html:
                      data.allDirectusScientificStudyTranslation.nodes[0]
                        .laboratory_test_text,
                  }}
                />
              )}
              {data.allDirectusScientificStudyTranslation.nodes[0]
                .laboratory_button_text && (
                <Button
                  to={
                    process.env.GATSBY_CURRENCY_TYPE === "eur" &&
                    intl.locale === "fr"
                      ? "/shop/solutions-textiles/"
                      : "/shop/"
                  }
                >
                  {
                    data.allDirectusScientificStudyTranslation.nodes[0]
                      .laboratory_button_text
                  }
                </Button>
              )}
              <div id="experts_section" />
              {data.allDirectusScientificStudyTranslation.nodes[0]
                .experts_section_title && (
                <SectionTitle
                  dangerouslySetInnerHTML={{
                    __html:
                      data.allDirectusScientificStudyTranslation.nodes[0]
                        .experts_section_title,
                  }}
                />
              )}
              {data.allDirectusScientificStudyTranslation.nodes[0]
                .experts_slider && (
                <ProductExpert
                  data={
                    data.allDirectusScientificStudyTranslation.nodes[0]
                      .experts_slider.list
                  }
                  page="scientific-study"
                />
              )}
              {data.allDirectusScientificStudyTranslation.nodes[0]
                .experts_slider && (
                <ScientificExpertSlider
                  data={
                    data.allDirectusScientificStudyTranslation.nodes[0]
                      .experts_slider.list
                  }
                />
              )}
            </Container>
          </PageSection>
          <PageSection background="#F8F8F8">
            <Container>
              {data.allDirectusScientificStudyTranslation.nodes[0]
                .our_references_section_title && (
                <SectionTitle
                  dangerouslySetInnerHTML={{
                    __html:
                      data.allDirectusScientificStudyTranslation.nodes[0]
                        .our_references_section_title,
                  }}
                  id="references"
                  marginBottom="25px"
                />
              )}
              {data.allDirectusScientificStudyTranslation.nodes[0]
                .our_references_text && (
                <ReferenceBox>
                  {data.allDirectusScientificStudyTranslation.nodes[0]
                    .our_references_title && (
                    <ReferenceTitle onClick={() => handleVisibility()}>
                      {
                        data.allDirectusScientificStudyTranslation.nodes[0]
                          .our_references_title
                      }
                    </ReferenceTitle>
                  )}
                  {showReference &&
                    data.allDirectusScientificStudyTranslation.nodes[0]
                      .our_references_text && (
                      <ReferenceText
                        dangerouslySetInnerHTML={{
                          __html:
                            data.allDirectusScientificStudyTranslation.nodes[0]
                              .our_references_text,
                        }}
                      />
                    )}
                  <OpenClose onClick={() => handleVisibility()}>
                    {showReference ? "-" : "+"}
                  </OpenClose>
                </ReferenceBox>
              )}
            </Container>

            {data.allDirectusScientificStudyTranslation.nodes[0]
              .sticky_banner_text &&
              data.allDirectusScientificStudyTranslation.nodes[0]
                .sticky_button_text && (
                <BottomStickyBanner>
                  <StickyContainer>
                    <StickyText
                      dangerouslySetInnerHTML={{
                        __html:
                          data.allDirectusScientificStudyTranslation.nodes[0]
                            .sticky_banner_text,
                      }}
                      lang={intl.locale}
                    />
                    <StickyButton
                      to={
                        process.env.GATSBY_CURRENCY_TYPE === "eur" &&
                        intl.locale === "fr"
                          ? "/shop/solutions-textiles/"
                          : "/shop/"
                      }
                    >
                      {
                        data.allDirectusScientificStudyTranslation.nodes[0]
                          .sticky_button_text
                      }
                    </StickyButton>
                  </StickyContainer>
                </BottomStickyBanner>
              )}
          </PageSection>
        </SectionContainer>

        {data.allDirectusFooterTranslation.nodes.length > 0 && (
          <Footer data={data.allDirectusFooterTranslation.nodes[0]} />
        )}
      </Fragment>
    )
  )
}

const BannerSection = styled.div`
  width: 100%;
  margin: 0px;
  position: relative;
`

const TopBannerImage = styled(GatsbyImage)`
  width: 100%;
  margin: 0px;
  min-height: 150px;

  @media (max-width: 550px) {
    min-height: 120px;
  }

  img {
    object-fit: cover !important;
  }
`

const BannerText = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  padding: 0px 20px;
  text-align: center;
`

const BannerTitle = styled.div`
  width: 100%;

  > h1 {
    text-transform: uppercase;
    font-family: "BebasNeueBold";
    font-weight: bold;
    color: #fff;
    font-size: 36px;
    line-height: 1.2;
    margin: 0px 0px 10px;

    @media (max-width: 850px) {
      font-size: 24px;
    }

    @media (max-width: 550px) {
      font-size: 24px;
      margin: 0px;
    }
  }

  > h1 > strong {
    font-family: "BebasNeueBold";
    font-weight: bold;

    @media (max-width: 550px) {
      display: block;
    }
  }
`

const BannerSubTitle = styled.div`
  width: 100%;

  > p {
    margin: 0px;
    color: #fff;
    font-size: 16px;
    line-height: 1.2;
    font-family: "Museo";
    font-weight: 500;
  }

  @media (max-width: 550px) {
    display: none;
  }
`

const MobileBannerSubTitle = styled.div`
  width: 100%;
  display: none;
  padding: 20px;

  > p {
    margin: 0px;
    color: #262626;
    font-size: 16px;
    line-height: 1.2;
    font-family: "Museo";
    font-weight: 500;
  }

  @media (max-width: 550px) {
    display: block;
    padding-bottom: 0px;
  }
`

const PageSection = styled.div`
  width: 100%;
  padding: 30px 20px;
  background-color: ${({ background }) => (background ? background : "#fff")};
`

const Container = styled.div`
  width: 100%;
  max-width: 1080px;
  margin: 0px auto;
  display: flex;
  flex-direction: column;
`

const SectionTitle = styled.h2`
  text-transform: uppercase;
  font-family: "BebasNeueBold";
  font-weight: bold;
  color: #262626;
  font-size: 35px;
  line-height: 1.2;
  margin: 0px 0px 10px;
  position: relative;
  padding-bottom: 5px;
  text-align: center;
  margin-bottom: ${({ marginBottom }) =>
    marginBottom ? marginBottom : "10px"};

  &:after {
    content: "";
    position: absolute;
    bottom: 0px;
    left: 50%;
    transform: translate(-50%, 0px);
    max-width: 100px;
    width: 100%;
    margin: 0px auto;
    background: #262626;
    height: 3px;
    border-radius: 3px;

    @media (max-width: 550px) {
      left: 0%;
      transform: translate(0px, 0px);
    }
  }

  @media (max-width: 550px) {
    font-size: 24px;
    text-align: left;
  }

  > span {
    @media (max-width: 550px) {
      display: block;
    }
  }
`

const ProductSectionSubTitle = styled.div`
  width: 100%;
  text-align: center;

  > p {
    margin: 0px;
    color: #262626;
    font-size: 16px;
    line-height: 1.2;
    font-family: "Museo";
    font-weight: 500;
  }

  a {
    text-decoration: underline;
  }

  @media (max-width: 550px) {
    text-align: left;
  }
`

const ProductActionSection = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 15px 0px;
  flex-wrap: wrap;
`

const ProductActionBox = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  flex-basis: 25%;
  box-sizing: border-box;
  max-width: 215px;
  padding: 10px 0px;

  @media (max-width: 550px) {
    flex-basis: 50%;
  }
`

const ProductActionImage = styled.img`
  width: 100%;
  max-width: 70px;
  margin: 0px;
`

const ProductActionText = styled.h3`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: #262626;
  font-size: 16px;
  line-height: 1.2;
  font-family: "Museo";
  font-weight: 700;
  margin: 10px 0px 0px;
  text-transform: uppercase;
`

const ProductTextSection = styled.div`
  width: 100%;
  display: flex;

  @media (max-width: 550px) {
    flex-direction: column-reverse;
  }
`

const LeftSection = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  margin-right: 15px;
  justify-content: space-between;

  @media (max-width: 550px) {
    margin: 0px;
  }
`

const Text = styled.div`
  width: 100%;

  > p {
    margin: 0 0 10px;
    color: #262626;
    font-size: 16px;
    line-height: 1.2;
    font-family: "Gotham Book";
    font-weight: 500;
  }

  a {
    text-decoration: underline;
  }
`

const ProductButton = styled(Link)`
  width: 100%;
  background-color: #262626;
  font-size: 16px;
  cursor: pointer;
  color: #fff;
  font-family: "Gotham Book";
  font-weight: 500;
  display: flex;
  max-width: 300px;
  justify-content: center;
  align-items: center;
  min-height: 45px;
  border-radius: 6px;

  &:hover {
    color: #fff;
  }

  @media (max-width: 550px) {
    max-width: 100%;
  }
`

const Button = styled(Link)`
  width: 100%;
  background-color: #262626;
  font-size: 16px;
  cursor: pointer;
  color: #fff;
  font-family: "Gotham Book";
  font-weight: 500;
  display: flex;
  max-width: 300px;
  justify-content: center;
  align-items: center;
  min-height: 45px;
  border-radius: 6px;
  margin: 20px auto 30px;

  &:hover {
    color: #fff;
  }

  @media (max-width: 550px) {
    max-width: 100%;
  }
`

const RightSection = styled.div`
  width: 100%;
  margin-left: 15px;

  @media (max-width: 550px) {
    margin: 0px -20px 20px;
    width: calc(100% + 40px);
  }
`

const RightImage = styled(GatsbyImage)`
  width: 100%;
  margin: 0px;
  border-radius: 6px;

  @media (max-width: 550px) {
    border-radius: 0px;
  }
`

const ProvenEffectSection = styled.div`
  width: 100%;
  background-color: #f8f8f8;
  padding: 30px 20px;

  @media (max-width: 550px) {
    margin: 0px 0px 20px;
  }
`

const Title = styled.h3`
  text-transform: uppercase;
  font-family: "BebasNeueBold";
  font-weight: bold;
  color: #262626;
  font-size: 35px;
  line-height: 1.2;
  margin: 0px 0px 10px;
  position: relative;
  text-align: center;
  margin-bottom: ${({ marginBottom }) =>
    marginBottom ? marginBottom : "10px"};

  @media (max-width: 550px) {
    font-size: 24px;
    text-align: left;
  }
`

const CustomerFeedbackBottomSection = styled.div`
  width: 100%;
  margin: 0px 0px 15px;
  display: flex;
  flex-direction: column;
  align-items: center;

  @media (max-width: 550px) {
    align-items: flex-start;
  }
`

const RightTitle = styled.div`
  font-family: "Gotham";
  font-weight: bold;
  color: #262626;
  font-size: 70px;
  line-height: 1;
  margin: 0px;
  position: relative;

  @media (max-width: 850px) {
    font-size: 48px;
  }
`

const RightSubTitle = styled.div`
  font-family: "GothamLight";
  font-weight: 500;
  color: #262626;
  font-size: 20px;
  line-height: 1.2;
  margin: 0px;
  position: relative;
  text-transform: uppercase;

  @media (max-width: 850px) {
    font-size: 16px;
  }
`

const ProcessBar = styled.div`
  height: 18px;
  background: linear-gradient(to right, #262626 92%, #f3f3f3 8%);
  max-width: 400px;
  width: 100%;
  border-radius: 3px;
  margin-bottom: 10px;
`

const SmallText = styled.div`
  font-family: "Gotham Book";
  font-weight: 500;
  color: #262626;
  font-size: 12px;
  line-height: 1.2;
  margin: 10px 0px 0px;
`

const ReferenceBox = styled.div`
  display: flex;
  flex-direction: column;
  box-shadow: 0px 3px 6px #00000029;
  border-radius: 6px;
  padding: 18px 15px;
  position: relative;
  transition: all 0.3s linear;
  background-color: #fff;
  color: #262626;
  font-size: 16px;
  line-height: 1.2;
`

const ReferenceTitle = styled.div`
  font-family: "Gotham";
  font-weight: bold;
`

const ReferenceText = styled.div`
  font-family: "Gotham Book";
  font-weight: 500;
  margin-top: 10px;

  > ul {
    margin-left: 0px 0px 0px 15px;
  }
`

const OpenClose = styled.div`
  position: absolute;
  right: 12px;
  top: 15px;
  width: 25px;
  height: 25px;
  border: 1.5px solid #111;
  border-radius: 50%;
  text-align: center;
  cursor: pointer;
  font-size: 20px;
  color: #111;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
`

const TrustPilotSection = styled.div`
  display: flex;
  flex-direction: column;
  background-color: #fff;
  justify-content: center;
  align-items: center;
  width: 100%;

  iframe {
    margin-bottom: 5px;
    margin-top: 5px;
  }
  @media (max-width: 550px) {
    align-items: flex-start;
  }
`

const DesktopTrustPilotSection = styled.div`
  width: 100%;

  @media (max-width: 550px) {
    display: none;
  }
`

const MobileTrustPilotSection = styled.div`
  width: 100%;
  display: none;

  @media (max-width: 550px) {
    display: block;
  }
`

const BottomStickyBanner = styled.div`
  display: flex;
  width: 100%;
  z-index: 3;
  position: fixed;
  bottom: 0px;
  background: #fff;
  color: #fff;
  left: 0;
  padding: 5px 20px;
  box-shadow: 0 0 15px 2px rgba(206, 206, 206, 0.5);

  @media (max-width: 550px) {
    padding: 10px 20px;
  }
`

const StickyContainer = styled.div`
  display: flex;
  max-width: 1080px;
  width: 100%;
  margin: 0px auto;
  align-items: center;
  justify-content: center;

  @media (max-width: 550px) {
    flex-direction: column;
  }
`

const StickyText = styled.div`
  color: #262626;
  font-size: 16px;
  line-height: 20px;
  font-family: "GothamLight";
  font-weight: bold;
  margin-right: 50px;
  text-transform: uppercase;

  @media (max-width: 550px) {
    font-size: 13px;
    line-height: 16px;
    margin: 0px 0px 10px;
  }

  @media (max-width: 420px) {
    font-size: ${({ lang }) => (lang === "en" ? "11px" : "13px")};
    line-height: 16px;
    margin: 0px 0px 10px;
  }

  @media (max-width: 360px) {
    font-size: 11px;
    line-height: 16px;
    margin: 0px 0px 10px;
  }
`

const StickyButton = styled(Link)`
  background: #008860;
  padding: 8px 15px;
  color: #fff;
  border-radius: 5px;
  font-size: 16px;
  font-family: "GothamLight";
  font-weight: bold;
  text-align: center;
  cursor: pointer;

  @media (max-width: 550px) {
    width: 100%;
  }

  :hover {
    color: #fff;
  }
`

export const query = graphql`
  query($lang: String!) {
    site {
      siteMetadata {
        title
      }
    }
    allDirectusScientificStudyTranslation(filter: { language: { eq: $lang } }) {
      nodes {
        top_banner_image {
          data {
            url
          }
          localFile {
            childImageSharp {
              gatsbyImageData(width: 1920, quality: 100)
            }
          }
        }
        top_banner_title
        top_banner_text
        lyne_product_section_title
        lyne_product_section_subtitle
        lyne_product_action {
          list {
            image
            text
          }
        }
        lyne_product_text
        lyne_product_right_image {
          data {
            url
          }
          localFile {
            childImageSharp {
              gatsbyImageData(width: 550, quality: 100)
            }
          }
        }
        lyne_product_button_text
        proven_effect_section_title
        proven_effect_section_text
        customer_feedback_title
        customer_feedback_bottom_section {
          left_section {
            title
            subtitle
          }
          right_section {
            title
            subtitle
          }
          mobile_text
        }
        customer_feedback_slider {
          list {
            logo
            bottom_text
            button_text
            button_url
            graph_text {
              value
              text
            }
            testimonials {
              name
              text
              designation
            }
          }
        }
        business_result_title
        business_result_slider {
          list {
            image
            text
            button_text
            button_url
          }
        }
        laboratory_test_title
        laboratory_test_text
        laboratory_button_text
        experts_section_title
        experts_slider {
          list {
            image
            name
            designation
            text
            video_text
            video_url
          }
        }
        our_references_section_title
        our_references_title
        our_references_text
        sticky_banner_text
        sticky_button_text
      }
    }
    allDirectusFooterTranslation(filter: { language: { eq: $lang } }) {
      nodes {
        facebook
        gbp_facebook
        youtube
        twitter
        instagram
        linkedin
        about_us {
          name
          list {
            link
            list
          }
        }
        contact {
          name
          list {
            link
            list
          }
          button {
            link
            list
          }
        }
        purchases {
          list {
            list
            link
          }
          name
        }
        help {
          list {
            link
            list
          }
          name
        }
        about_us_menu {
          name
          list {
            link
            list
          }
        }
        knowledge_center_menu {
          name
          list {
            link
            list
          }
        }
        shop_menu {
          name
          list {
            link
            list
          }
        }
        support_menu {
          name
          list {
            link
            list
          }
          button {
            link
            list
          }
        }
        newsletter_heading
        follow_us_heading
        footer_bottom {
          list {
            link
            list
          }
        }
      }
    }
    allDirectusSeoTranslation(
      filter: {
        language: { eq: $lang }
        seo: { page_name: { eq: "dispositif_medical" } }
      }
    ) {
      nodes {
        meta_title
        meta_description
        twitter_card
        twitter_title
        url
        image {
          data {
            url
          }
        }
      }
    }
  }
`

export default injectIntl(ScientificStudy)
